module.exports = __webpack_public_path__ + "media/images/arrow-e4fe660d804c281f4f329eb3d3f35cb4.svg";